<template>
  <div class="top-list">
    <node-benefit-teaser
      v-for="teaser in benefits?.rows"
      v-bind="teaser"
      :key="teaser.nid"
      class="is-vertical-mobile"
    />
  </div>
</template>

<script setup lang="ts">
import type { NodeBenefitTeaserFragment } from '#graphql-operations'

const { data: benefits } = await useAsyncData(async () => {
  return await useGraphqlQuery('benefitsListSticky').then((v) => {
    return {
      rows:
        // @ts-ignore
        (v.data?.entityById?.executable?.execute
          ?.rows as NodeBenefitTeaserFragment[]) || [],
      // @ts-ignore
      totalRows: v.data?.entityById?.executable?.execute.total_rows || 0,
    }
  })
})
</script>
